import { apiClient } from '@repo/shared';

const initialiseNewAttendance = () => {
  return {
    class: {},
    attendances: [],
  };
}

const getForClass = async (classId) => {
  const attendancesResponse = await apiClient.get(`/api/classes/${classId}/attendance`);
  console.log(attendancesResponse);
  const attendances = attendancesResponse?.map(a => { return {...a, classDate: new Date(a.classDate)} });
  return attendances;
};

const update = async ({classId, attendances} ) => {
  return await apiClient.post(`/api/classes/${classId}/attendance`, attendances);
};


const AttendanceService = {
    getForClass,
    update,
    initialiseNewAttendance,
  };
  
  export default AttendanceService;